<template>
  <div
    v-if="isAddWidgetModalVisible"
    class="fixed top-0 left-0 flex justify-center items-center w-full h-full bg-modal z-50"
  >
    <AddWidgetModal
      @close="isAddWidgetModalVisible = false"
    />
  </div>

  <div class="main-content mb-8">
    <div class="flex gap-4">
      <div class="title flex-auto">
        <h1 class="text-lg">
          {{ changeCase('my widgets', ElementE.TITLE) }}
        </h1>
      </div>

      <ToastPopup
        v-if="showErrorToast"
        status="error"
        :text="errorMessage"
        @close="showErrorToast = false"
      />

      <div class="add-widget flex-initial h-12">
        <AddWidgetBtn
          v-if="showAddWidgetButton || widgets === undefined"
          @click="isAddWidgetModalVisible = true"
        />
      </div>

      <ToastPopup
        v-if="showDeleteWidgetToast"
        status="success"
        :text='`"${deletedWidgetTitle}" has been deleted`'
        :width="300"
        @close="showDeleteWidgetToast = false"
      />
    </div>

    <div class="mt-6 rounded-lg shadow-default">
      <WidgetCard
        v-for="(item, i) in widgets"
        :key="item.id"
        :id="item.id"
        :title="item.name"
        :widget_id="item.id"
        :widget_description="item.description"
        :is-first="i === 0"
        :is-last="i === widgets.length - 1"
        @deleted="handleWidgetDelete"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import axios from "axios";
import WidgetCard from "../components/WidgetCard.vue";
import AddWidgetModal from '../components/modals/AddWidgetModal.vue';
import AddWidgetBtn from "../components/buttons/AddWidgetBtn.vue";
import ToastPopup from "../components/notifications/ToastPopup.vue";
import { WidgetI } from "../interfaces/interfaces";
import { changeCase } from "../helpers";
import { ElementE } from '../enums';

const widgets = ref<WidgetI[]>([]);
const isError = ref<boolean>(false);
const errorMessage = ref<string>('');
const deletedWidgetTitle = ref<string>('');
const showDeleteWidgetToast = ref<boolean>(false);
const showErrorToast = ref<boolean>(false);
const showAddWidgetButton = ref<boolean>(true);
const isAddWidgetModalVisible = ref<boolean>(false);

const handleWidgetDelete = (id: number | string, title: string) => {
  widgets.value = widgets.value.filter(widget => widget.id !== id);

  showDeleteWidgetToast.value = true;
  deletedWidgetTitle.value = title;
}

onMounted(async() => {
  const token = sessionStorage.getItem("TOKEN");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API}v3/get-widgets`, config);
    widgets.value = data.sort((a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error(error);
    errorMessage.value = 'Widgets are not found';
    isError.value = true;
  }
});

watch(() => isError.value, (value: boolean) => {
  if (value) {
    showErrorToast.value = true;

    setTimeout(() => {
      isError.value = false;
      showErrorToast.value = false;
    }, 5000);
  }
});

watch(() => [showDeleteWidgetToast.value, showErrorToast.value], ([newValueOne, newValueTwo]) => {
  if (newValueOne) {
    setTimeout(() => {
      showDeleteWidgetToast.value = false;
    }, 3000);
  }

  if (newValueOne || newValueTwo) {
    showAddWidgetButton.value = false;
    return;
  }
  showAddWidgetButton.value = true;
});
</script>
